'use strict';

import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.

window.jQuery = $;

require('./lib/viewport'); // Voeg een class toe als element in beeld is (optioneel).

require('foundation-sites');
require('lazyload');
//require('mmenu-js');
//require('@fancyapps/fancybox');
//require('slick-carousel');

var raadhuis = require('./lib/default'); // Standaard JS functions (Slick slider, mmenu, sticky nav etc.).

// If you want to pick and choose which modules to include, comment out the above and uncomment the line below, go to the file and comment :
// import './lib/foundation-explicit-pieces';

$(document).ready(function () {
  // Custom jQuery code here
  lazyload();

  $('body').removeClass('preload');

  // raadhuis.scrollToAnchor('.scroll-to-anchor');

  $('.menu-button').on('click', function (e) {
    e.preventDefault();
    $('body').toggleClass('menu-open');
  });

  $('.read-more-link').click(function () {
    $('.read-more-text').toggle();
    $(this).toggleClass('active');
  });

  // Navigatie
$(document).on('click', '.submenu-arrow', function(e) {
  e.preventDefault();
  e.stopPropagation();
  var parent = $(this).closest('.menu-item-has-children');
  parent.toggleClass('is-open');

  $('.menu-item-has-children').not(parent).removeClass('is-open');
});

if (window.matchMedia('(min-width: 64em)').matches) {
  $('.menu-item-has-children').on('mouseenter', function () {
    $(this).addClass('is-open');
  }).on('mouseleave', function () {
    $(this).removeClass('is-open');
  });
}

  $('.menu-item-has-children > a').append('<span class="submenu-arrow" aria-expanded="false"></span>');  
  
  // Search   
  $('.nav__search-button').on('click', function (e) {
    e.preventDefault();
    $('body').toggleClass('search-open');

    setTimeout(function () {
      $('.nav__search .search input[type=search], .nav__search .search input[type=text]').focus();
    }, 300);

    toggleAriaExpanded(this);
  });

  //switchen content Visie
  $('.contentswitch').hide();
  $('#content1').show();
  $('.support-emma').on('click', function () {
    var contentID = $(this).data('switch');
    $('.contentswitch').hide();
    $('#' + contentID).fadeToggle();
    $('.support-emma').removeClass('active');
    $(this).addClass('active');
  });

  var stickyPosition;

  if ($('.sticky-buttons').length > 0) {
    stickyPosition = $('.content').offset().top - 2000;
  }

  function stickyNav() {
    if ($(window).scrollTop() > stickyPosition) {
      $('.sticky-buttons ').addClass('sticky');
    } else {
      $('.sticky-buttons ').removeClass('sticky');
    }

    //console.log('buttons '  + stickyPosition);
    //console.log('scrolltop '  + $(window).scrollTop()) ;

  }

  stickyNav();

  $(window).on('scroll', function (e) {
    stickyNav();
  });

  $(document).foundation();

  $(document).on('click', 'a[href^="#"]', function (e) {
    // target element id
    var id = $(this).attr('href');

    var $id = $(id);
    if ($id.length === 0) {
      return;
    }

    // prevent standard hash navigation (avoid blinking in IE)
    e.preventDefault();

    var pos = $id.offset().top - 0;

    // animated top scrolling
    $('body, html').animate({
      scrollTop: pos
    });
  });
});